import React from "react";
import { HeaderImageComponent } from "./HeaderImageComponent";
import { PrimaryButtonComponent } from "./PrimaryButtonComponent";
import { SecondaryButtonComponent } from "./SecondaryButtonComponent";

export const Firstscreen = () => {
  return (
    <div className="flex flex-col justify-center items-center h-2/3 w-full md:h-screen">
      <div className="flex flex-col justify-center items-center w-11/12 mb-14 md:flex-row-reverse md:w-4/5 md:h-5/6 ">
        <div className="flex flex-col justify-center items-center h-full">
          <HeaderImageComponent />
        </div>
        <div className="mt-12 md:h-full md:mt-0 md:flex md:flex-col md:justify-center md:min-w-[540px]">
          <div className="md:w-11/12 ">
            <h1 className="text-2xl md:text-4xl text-left font-newFont md:leading-snug">
              <span className="text-primaryBlue font-black">Tecnología </span>{" "}
              <span className="text-primaryBlack font-black">
                para gobiernos conectados y ciudades más inteligentes{" "}
              </span>
            </h1>
            <p className="text-left text-primaryBlack text-lg mt-4 font-newFont">
              Moderniza la gestión pública con datos en tiempo realm
              herramientas colaborativas y un ecosistema que modeja el servicio
              a la ciudadanía.
            </p>
          </div>
          <div className="h-36 flex flex-col justify-around items-center mt-4 md:flex-row-reverse md:w-3/4 md:min-w-[400px] md:justify-between ">
            <SecondaryButtonComponent />
            <PrimaryButtonComponent />
          </div>
        </div>
      </div>
    </div>
  );
};
